import ReactDOM from "react-dom";
import App from "./App";

import "../src/assets/CSS/reset.css"
import "../src/assets/CSS/style.css"

ReactDOM.render(<App />, document.querySelector(".root"));